import React from "react";
import { connect } from "react-redux";
import OpcionesComponent from "./Componentes/Opciones/Opciones.component";
import ClienteComponent from "./Componentes/Cliente/Cliente.component";
import DespachoComponent from "./Componentes/Despacho/Despacho.component";
import ResumenComponent from "./Componentes/Resumen/Resumen.component";
import ProductosComponent from "./Componentes/Productos/Productos.component";
import TotalComponent from "./Componentes/Total/Total.component";
import LoaderPortal from "./../../Portales/Loader/Loader.portal";
import ModalMensajeComponent from "./../../Shared/Componentes/ModalMensaje/ModalMensaje.component";
import ModalConfirmacionComponent from "../../Shared/Componentes/ModalConfirmacion/ModalConfirmacion.component";
import * as CotizacionActions from "./../../Core/Actions/Cotizacion.action";
import * as SucursalActions from "./../../Core/Actions/Sucursal.action";
import "./Carrito.page.scss";

const divOpciones = {
  Productos: {
    id: "divProductos",
    estilo: "Carrito__Opciones--Productos",
    estiloActivo: "Carrito__Opciones--Productos-Activo",
  },
  Cliente: {
    id: "divCliente",
    estilo: "Carrito__Opciones--Cliente",
    estiloActivo: "Carrito__Opciones--Cliente-Activo",
  },
  Envio: {
    id: "divEnvio",
    estilo: "Carrito__Opciones--Envio",
    estiloActivo: "Carrito__Opciones--Envio-Activo",
  },
  Resumen: {
    id: "divResumen",
    estilo: "Carrito__Opciones--Resumen",
    estiloActivo: "Carrito__Opciones--Resumen-Activo",
  },
};

class CarritoPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Modal: {
        Mostrar: false,
        Mensaje: "",
      },
      Confirmacion: {
        Mostrar: false,
        Mensaje: "",
        Tipo: "",
        Dato: {},
      },
      TiposConf: {
        EliminarArticulo: "ELIMINAR_ARTICULO",
        CerrarPedido: "CERRAR_PEDIDO",
        AnularPedido: "ANULAR_PEDIDO",
      },
      OpcionActual: "",
      Despacho: {},
      Sucursal: {},
    };
  }

  componentDidMount() {
    this.setState({
      Modal: {
        Mostrar: false,
        Mensaje: "",
      },
      Confirmacion: {
        Mostrar: false,
        Mensaje: "",
        Tipo: "",
        Dato: {},
      },
      TiposConf: {
        EliminarArticulo: "ELIMINAR_ARTICULO",
        CerrarPedido: "CERRAR_PEDIDO",
        AnularPedido: "ANULAR_PEDIDO",
      },
      OpcionActual: "",
      Despacho: {},
      Sucursal: {},
    });

    this.BuscarCotizacionActual();
    this.BuscarSucursales();
  }

  BuscarCotizacionActual = async () => {
    const { buscarCotizacionActual } = this.props;
    await buscarCotizacionActual();

    if (this.props.cotizacionReducer.Resultado === "E") {
      this.setState({
        Modal: {
          Mostrar: true,
          Mensaje: this.props.cotizacionReducer.Mensaje,
        },
      });
      return;
    }
  };

  BuscarSucursales = async () => {
    const { Sucursales } = this.props.sucursalReducer;

    if (Sucursales.length <= 0) {
      const { obtenerSucursales } = this.props;
      await obtenerSucursales();
    }
  };

  handleOpcionActual = (actual) => {
    this.setState({
      OpcionActual: actual,
    });
  };

  handleMostrarModal = () => {
    this.setState({
      Modal: {
        Mostrar: !this.state.Modal.Mostrar,
        Mensaje: "",
      },
    });
  };

  hadleModificarCarrito = async (producto) => {
    const { actualizarCotizacion } = this.props;
    await actualizarCotizacion([producto]);

    if (this.props.cotizacionReducer.Resultado !== "S") {
      this.setState({
        Modal: {
          Mostrar: true,
          Mensaje: this.props.cotizacionReducer.Mensaje,
        },
      });
      return;
    }
  };

  handleEliminarArticulo = (producto) => {
    const msjModal = `¿Desea eliminar ${producto.Descripcion}?`;

    this.setState({
      Confirmacion: {
        Mostrar: !this.state.Confirmacion.Mostrar,
        Mensaje: msjModal,
        Tipo: this.state.TiposConf.EliminarArticulo,
        Dato: producto,
      },
    });
  };

  handleAnularCarrito = () => {
    const msjModal = `¿Desea anular la cotización?`;

    this.setState({
      Confirmacion: {
        Mostrar: !this.state.Confirmacion.Mostrar,
        Mensaje: msjModal,
        Tipo: this.state.TiposConf.AnularPedido,
        Dato: {},
      },
    });
  };

  handleConfirmarCarrito = () => {
    const { Tipo = "" } = this.state.Despacho;
    console.log(Tipo);

    this.setState({
      OpcionActual:
        Tipo === "" ? divOpciones.Envio.id : divOpciones.Resumen.id,
    });
  };

  handleCerrarCarrito = () => {
    const msjModal = `¿Desea cerrar la cotización?`;

    this.setState({
      Confirmacion: {
        Mostrar: !this.state.Confirmacion.Mostrar,
        Mensaje: msjModal,
        Tipo: this.state.TiposConf.CerrarPedido,
        Dato: {},
      },
    });
  };

  handleCerrarModal = () => {
    this.setState({
      Confirmacion: {
        Mostrar: !this.state.Confirmacion.Mostrar,
        Mensaje: "",
        Dato: {},
      },
    });
  };

  handleSiModal = async () => {
    const { Tipo } = this.state.Confirmacion;
    this.handleCerrarModal();

    switch (Tipo) {
      case this.state.TiposConf.EliminarArticulo:
        const { Dato: producto } = this.state.Confirmacion;

        const { eliminarArticuloCotizacion } = this.props;
        await eliminarArticuloCotizacion(producto);

        if (this.props.cotizacionReducer.Resultado !== "S") {
          this.setState({
            Modal: {
              Mostrar: true,
              Mensaje: this.props.cotizacionReducer.Mensaje,
            },
          });
          return;
        }

        break;

      case this.state.TiposConf.AnularPedido:
        const { anularCotizacion } = this.props;
        await anularCotizacion();

        if (this.props.cotizacionReducer.Resultado !== "S") {
          this.setState({
            Modal: {
              Mostrar: true,
              Mensaje: this.props.cotizacionReducer.Mensaje,
            },
          });
          return;
        }

        break;

      case this.state.TiposConf.CerrarPedido:
        const { cerrarCotizacion } = this.props;
        const { Despacho, Sucursal } = this.state;
        await cerrarCotizacion(Despacho, Sucursal);

        if (this.props.cotizacionReducer.Resultado !== "S") {
          this.setState({
            Modal: {
              Mostrar: true,
              Mensaje: this.props.cotizacionReducer.Mensaje,
            },
          });
          return;
        }

        break;

      default:
        break;
    }
  };

  handleNoModal = () => {
    this.handleCerrarModal();
  };

  opcionActual = () => {
    const { OpcionActual, Despacho, Sucursal } = this.state;
    const { Cliente } = this.props.loginReducer;
    const { Sucursales } = this.props.sucursalReducer;
    const { PedidoActual: Cotizacion = {} } = Cliente?.datos;
    let Productos = [];

    if (Cotizacion) {
      Productos = Cotizacion?.datos?.Productos || [];
    }

    switch (OpcionActual) {
      case divOpciones.Cliente.id:
        return <ClienteComponent cliente={Cliente} />;

      case divOpciones.Envio.id:
        return (
          <DespachoComponent
            sucursales={Sucursales}
            metodoDespacho={this.metodoDespacho}
          />
        );

      case divOpciones.Resumen.id:
        return (
          <ResumenComponent
            cotizacion={Cotizacion}
            cliente={Cliente}
            despacho={Despacho}
            sucursal={Sucursal}
            cerrarCotizacion={this.handleCerrarCarrito}
          />
        );

      default:
        return (
          <ProductosComponent
            productos={Productos}
            modificarCarrito={this.hadleModificarCarrito}
            eliminarArticulo={this.handleEliminarArticulo}
          />
        );
    }
  };

  metodoDespacho = (metodo, Sucursal) => {
    const despacho = {
      Tipo: metodo,
    };

    this.setState({
      Despacho: despacho,
      Sucursal: Sucursal,
    });
  };

  render() {
    return (
      <>
        <LoaderPortal />
        <ModalMensajeComponent
          mostrar={this.state.Modal.Mostrar}
          handleCerrar={this.handleMostrarModal}
        >
          <h5>{this.state.Modal.Mensaje}</h5>
        </ModalMensajeComponent>
        <ModalConfirmacionComponent
          mostrar={this.state.Confirmacion.Mostrar}
          handleCerrar={this.handleCerrarModal}
          handleSi={this.handleSiModal}
          handleNo={this.handleNoModal}
        >
          <h5 className="font-italic">{this.state.Confirmacion.Mensaje}</h5>
        </ModalConfirmacionComponent>
        <OpcionesComponent
          cambiarOpcion={this.handleOpcionActual}
          divOpciones={divOpciones}
        />
        <div className="Carrito">
          <div className="Carrito__Contenedor-Opciones">
            {this.opcionActual()}
          </div>
          <div className="Carrito__Contenedor-Resumen">
            <TotalComponent
              productos={
                this.props.loginReducer.Cliente?.datos?.PedidoActual?.datos
                  ?.Productos || []
              }
              codigo={
                this.props.loginReducer.Cliente?.datos?.PedidoActual?.datos
                  ?.Codigo || []
              }
              anularCotizacion={this.handleAnularCarrito}
              confirmarCotizacion={this.handleConfirmarCarrito}
            />
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = ({
  loginReducer,
  cotizacionReducer,
  sucursalReducer,
}) => {
  return {
    loginReducer,
    cotizacionReducer,
    sucursalReducer,
  };
};

const mapDispatchToProps = { ...CotizacionActions, ...SucursalActions };

export default connect(mapStateToProps, mapDispatchToProps)(CarritoPage);
